const Roles = {
  ZOBU_CHAT_ADMIN: "zobu_chat_admin",
  GEETA_CENTRAL: "geeta_central",
  CRS_ADMIN: "crs_admin",
  CENTRAL_BOOKING_ADMIN: "central_booking_admin",
  CENTRAL_BOOKING_AGENT: "central_booking_agent",
  ZOBU_CHAT_AGENT: "zobu_chat_agent",
  HOST: "host",
  PARTNER_ONBOARDING: "partner_onboarding",
  PARTNER_CHECKIN: "manager_partner",
};

export default Roles;
